<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'conversations'"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="card-header">
							<h1 class="fs-20">{{$t('menu.conversations')}}</h1>
						</div>
						<template v-if="messageList.length > 0">
							<div class="conversation-list">
								<div class="conversations-card">
									<div class="conversations-item" v-for="item in messageList">
										<div class="conversation-box" @click="toDetail(item.storeMessageNo)">
											<div class="conversation-content-wrapper">
												<div class="conversation-shop">
													<div class="conversation-avatar"
														style="height: 48px; min-width: 48px; width: 48px;">
														<img :src="item.memberImg" class="conversation-avatar-img" />
													</div>
													<div class="conversation-shop-info">
														<el-badge is-dot :hidden="item.messageHuifu == 2 ? false : true">
															<div class="conversation-shop-name" style="margin: 0 5px 4px 0;">{{item.memberName}}</div>
														</el-badge>
														<div class="conversation-date">{{formatTo12Hour(item.updateTime)}}</div>
													</div>
												</div>
												<div class="conversation-message">
													<a class="conversation-title">{{item.productName}}</a>
													<div class="conversation-details">
														<template v-if="item.content">
															<div class="conversation-text">{{item.content}}</div>
														</template>
														<template v-else-if="item.imgUrl">
															<div class="conversation-img-container">
																<el-image :src="item.imgUrl" class="conversation-img">
																</el-image>
															</div>
														</template>
														<template v-else>
															<div class="mt-2">
																<div class="product-image-only">
																	<img :src="item.productPhoto"
																		class="image-product-contain" />
																</div>
															</div>
														</template>

													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="pagination-container" style="justify-content: flex-end;">
								<el-pagination background :page-count="isMobile ? 4 : 10" layout="prev, pager, next"
									:total="total" :current-page.sync="queryParams.pageNum"
									:page-size="queryParams.pageSize" @current-change="getMessageList">
								</el-pagination>
							</div>
						</template>
						<template v-else>
							<div style="width: 100%;margin-top: 30px;height: auto;">
								<empty></empty>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
		<tabBar ref="tabBarRef"></tabBar>
	</div>
</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import empty from '../../components/empty.vue'
	import {
		messageList
	} from "@/api/message";

	export default {
		components: {
			headerNav,
			sideBar,
			tabBar,
			empty
		},
		data() {
			return {
				tableLoading: false,
				total: 0,
				messageList: [],
				queryParams: {
					pageNum: 1,
					pageSize: 10,
				},
				isMobile: false
			}
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.getMessageList();
		},
		methods: {
      formatTo12Hour(timeStr) {
        if (!timeStr) return '';

        // 假设 createTimestr 是 "YYYY-MM-DD HH:mm:ss" 格式
        const date = new Date(timeStr);

        if (isNaN(date.getTime())) {
          // 如果不是标准日期格式，直接返回原值
          return timeStr;
        }

        // 使用 toLocaleString 方法转换为12小时制
        return date.toLocaleString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true
        });
      },
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
				this.$refs.tabBarRef.handleBrage()
			},
			getMessageList() {
				messageList(this.queryParams).then(res => {
					if (res.code == 200) {
						this.messageList = res.rows
						this.total = res.total
					}
				})
			},
			// 	currentPage 改变时会触发
			handleCurrentChange(currentPage) {
				this.queryParams.pageNum = currentPage;
				this.getMessageList()
			},
			// 	用户点击上一页按钮改变当前页后触发
			handlePrevClick(currentPage) {
				this.queryParams.pageNum = currentPage;
				this.getMessageList()
			},
			// 用户点击下一页按钮改变当前页后触发
			handleNextClick(currentPage) {
				this.queryParams.pageNum = currentPage;
				this.getMessageList()
			},
			toDetail(storeMessageNo) {
				//localStorage.setItem('cqty', 0);
				this.openPage('conversations-message?no=' + storeMessageNo)
			}
		}
	}
</script>
<style scoped>
	@import url("../../assets/css/message.css");

	.table-container {
		padding: 5px 20px 85px;
	}

	.conversation-list {
		margin-top: 20px;
		/* border: 1px solid #e0e0e0; */
		/* border-radius: 8px; */
		/* overflow: hidden; */
	}

	.conversation-item {
		display: flex;
		padding: 16px;
		border-bottom: 1px solid #f0f0f0;
		transition: background-color 0.2s ease;
		cursor: pointer;
	}

	.conversation-item:hover {
		background-color: #f8f9fa;
	}

	.avatar-wrapper {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		overflow: hidden;
	}

	.avatar {
		width: 100%;
		height: 100%;
		top: 10px;
		object-fit: cover;
	}

	.conversation-content {
		flex: 1;
		margin-left: 16px;
	}

	.user-info {
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #333;
	}

	.timestamp {
		margin-left: 8px;
		color: #666;
		font-size: 12px;
	}

	.product-title {
		font-weight: 500;
		color: #000;
		margin: 4px 0;
		font-size: 14px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.message {
		color: #666;
		font-size: 12px;
		line-height: 1.4;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.pagination-container {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 20px;
		padding: 0 16px;
	}

	.pagination-info {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.pagination-controls {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.pagination-controls button {
		background: none;
		border: 1px solid #ccc;
		border-radius: 4px;
		padding: 4px 8px;
		cursor: pointer;
	}

	.pagination-controls button:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}

	.current-page {
		font-weight: bold;
		padding: 4px 8px;
		background-color: #007bff;
		color: white;
		border-radius: 4px;
	}

	.goto-container {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.goto-container input {
		width: 60px;
		padding: 4px;
		border: 1px solid #ccc;
		border-radius: 4px;
	}

	/* 移动端适配 */
	@media (max-width: 768px) {
		.conversation-item {
			flex-direction: column;
			align-items: flex-start;
			padding: 12px;
		}

		.avatar-wrapper {
			width: 36px;
			height: 36px;
			margin-bottom: 8px;
		}

		.avatar {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		.conversation-content {
			margin-left: 0;
			width: 100%;
		}

		.user-info {
			font-size: 12px;
		}

		.timestamp {
			font-size: 10px;
		}

		.product-title {
			font-size: 13px;
			-webkit-line-clamp: 2;
		}

		.message {
			font-size: 11px;
			-webkit-line-clamp: 2;
		}

		.pagination-container {
			flex-direction: column;
			gap: 12px;
		}

		.pagination-info,
		.pagination-controls,
		.goto-container {
			width: 100%;
			justify-content: center;
		}

		.pagination-controls {
			gap: 4px;
		}

		.pagination-controls button {
			padding: 2px 6px;
			font-size: 12px;
		}

		.current-page {
			padding: 2px 6px;
			font-size: 12px;
		}

		.goto-container input {
			width: 50px;
			padding: 2px;
			font-size: 12px;
		}
	}
	.el-badge__content.is-fixed.is-dot {
		right: 0px !important;
	}
  .unread {
    width: 6px;
    height: 6px;
    background-color: red;
    border-radius: 50px;
    position: absolute;
    top: 10px;
    right: 31px;
  }
</style>
